import { createPlanText } from "../constants/data";

export const positiveIntegerRegEx = /^[1-9]\d*$/;
export const nonNegativeIntegerRegEx = /^(0|[1-9]\d*)$/;

export const planValidationRules = {
  planName: {
    required: true,
    validator: {
      regEx: /.+/,
      errEmpty: createPlanText.errors.planNameRequired,
      error: createPlanText.errors.planNameRequired,
    },
  },
  billingCycle: {
    required: true,
    validator: {
      regEx: /.+/,
      errEmpty: createPlanText.errors.billingCycleRequired,
      error: createPlanText.errors.billingCycleRequired,
    },
  },
  price: {
    required: true,
    validator: {
      regEx: nonNegativeIntegerRegEx,
      errEmpty: createPlanText.errors.priceRequired,
      error: createPlanText.errors.priceInvalid,
    },
  },
  country: {
    required: true,
    validator: {
      regEx: /.+/,
      errEmpty: createPlanText.errors.countryRequired,
      error: createPlanText.errors.countryRequired,
    },
  },
  currency: {
    required: true,
    validator: {
      regEx: /.+/,
      errEmpty: createPlanText.errors.currencyRequired,
      error: createPlanText.errors.currencyRequired,
    },
  },
  maxEmployees: {
    required: true,
    validator: {
      regEx: positiveIntegerRegEx,
      errEmpty: createPlanText.errors.maxEmployeesRequired,
      error: createPlanText.errors.maxEmployeesInvalid,
    },
  },
  payslipsPerYear: {
    required: true,
    validator: {
      regEx: positiveIntegerRegEx,
      errEmpty: createPlanText.errors.payslipsRequired,
      error: createPlanText.errors.payslipsInvalid,
    },
  },
};

export const moduleNumericFieldKeys = [
  "companies",
  "operatorsPerPlan",
  "invoice",
  "invoiceValueCap",
  "attendanceDays",
  "loans",
  "deductions",
  "leaveRequests",
  "commissionRuns",
  "travelClaims",
  "allowances",
  "employeeDocsPerEmployee",
  "recruitment",
  "timesheet",
  "projects",
  "payrollRuns",
  "reportDownloads",
  "documentsUploadPerEmployee",
];

export const sanitizePositiveIntegerInput = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[^0-9]/g, "");
};

export const coercePositiveIntegerInput = (value) => {
  const numericValue = sanitizePositiveIntegerInput(value);
  if (numericValue === "" || /^0+$/.test(numericValue)) return "";
  // Strip leading zeros
  return numericValue.replace(/^0+/, "");
};

export const coerceNonNegativeIntegerInput = (value) => {
  const numericValue = sanitizePositiveIntegerInput(value);
  if (numericValue === "") return "";
  if (/^0+$/.test(numericValue)) return "0";
  // Strip leading zeros
  return numericValue.replace(/^0+/, "");
};

export const getPlanFieldError = (name, value) => {
  const rule = planValidationRules[name];
  if (!rule) return "";

  const rawValue = value === null || value === undefined ? "" : String(value);
  const trimmed = rawValue.trim();

  if (rule.required && !trimmed) {
    return rule.validator.errEmpty;
  }

  if (!rule.required && !trimmed) return "";

  if (rule.validator && rule.validator.regEx && !rule.validator.regEx.test(trimmed)) {
    return rule.validator.error;
  }

  return "";
};

export const validatePlanForm = (formData) => {
  const errors = {};
  Object.keys(planValidationRules).forEach((key) => {
    const err = getPlanFieldError(key, formData[key]);
    if (err) errors[key] = err;
  });
  return errors;
};
